import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import './i18n'
import App from './App'
import { APP_VERSION } from './version'

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    environment: import.meta.env.MODE,
    release: APP_VERSION,
    sendDefaultPii: false,
  })
  ;(window as unknown as Record<string, unknown>).Sentry = Sentry
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p style={{ padding: '2rem' }}>Er is een onverwachte fout opgetreden. Ververs de pagina om opnieuw te proberen.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
